<template>
  <main-content>
    <el-form inline>
      <div class="flex justify-between">
        <div>
          <el-form-item label="菜单名称">
            <el-input
              placeholder="请输入菜单名称"
              clearable
              v-model="searchParams.name"
            />
          </el-form-item>
          <el-form-item label="状态">
            <el-select clearable v-model="searchParams.status">
              <el-option label="启用" :value="MENU_STATUS.NORMAL" />
              <el-option label="禁用" :value="MENU_STATUS.DISABLED" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </div>
        <div>
          <el-button type="primary" @click="visible = true">新建</el-button>
        </div>
      </div>
    </el-form>
    <el-table
      :data="menuData"
      row-key="id"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column label="菜单名称">
        <template slot-scope="scope">
          <b>{{ scope.row.name }}</b>
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="order" width="60" />
      <el-table-column label="类型" width="66">
        <template slot-scope="scope">
          <el-tag effect="dark" :type="TAG_TYPE[scope.row.type]">{{
            MENU_TYPE_TEXT[scope.row.type]
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="路由" prop="href" />
      <el-table-column label="请求地址" prop="url" />
      <el-table-column label="权限标识" prop="perms" />
      <el-table-column label="启用/禁用">
        <template slot-scope="scope">
          <el-switch
            :title="MENU_STATUS_TEXT[scope.row.status]"
            :value="scope.row.status"
            :active-value="MENU_STATUS.NORMAL"
            :inactive-value="MENU_STATUS.DISABLED"
            @change="handleChangeMenuStatus(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="菜单导航" prop="visible">
        <template slot-scope="scope">
          <span v-show="scope.row.visible === MENU_VISIBLE.SHOW">显示</span>
          <span
            v-show="scope.row.visible === MENU_VISIBLE.HIDE"
            style="color: #f55e04"
          >
            隐藏
          </span>
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="remarks" />
      <el-table-column label="操作" width="100px" align="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="margin-right: 10px"
            @click="handleEdit(scope)"
          >
            修改
          </el-button>
          <el-popconfirm
            title="确定删除当前菜单及其所有子菜单吗?"
            @confirm="handleDelete(scope)"
          >
            <el-button slot="reference" type="text" style="color: red">
              删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="visible"
      :title="form.id ? '编辑功能' : '新建功能'"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="80px"
        style="padding: 0 30px"
      >
        <el-form-item label="类型" required prop="type">
          <el-radio-group
            :disabled="isDisabled"
            v-model="form.type"
            @change="handleMenuTypeChange"
          >
            <el-radio
              v-for="item in menuTypeOptions"
              :key="item.value"
              :label="item.value"
            >
              {{ item.name }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上级菜单" prop="parentId">
          <el-cascader
            v-model="form.parentId"
            :options="menuDir"
            filterable
            :props="defaultProps"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item
          :label="menuName"
          prop="name"
          :rules="[
            { required: true, message: menuName + '不能为空' },
            { pattern: /[^\s]/, message: '不能以空格开头' },
          ]"
        >
          <el-input v-model="form.name" maxlength="10" placeholder="请输入" />
        </el-form-item>
        <el-form-item
          v-if="form.type !== MENU_TYPE.BUTTON"
          label="路由"
          prop="href"
          :rules="[
            { required: true, message: '路由不能为空' },
            { pattern: /[^\s]/, message: '不能以空格开头' },
          ]"
        >
          <el-input v-model="form.href" placeholder="请输入路由" />
        </el-form-item>
        <el-form-item
          v-if="form.type === MENU_TYPE.BUTTON"
          label="请求地址"
          prop="url"
        >
          <el-input v-model="form.url" placeholder="请输入请求地址" />
        </el-form-item>
        <el-form-item
          v-if="form.type === MENU_TYPE.BUTTON"
          label="授权标识"
          prop="perms"
          :rules="[{ required: true, message: '授权标识不能为空' }]"
        >
          <el-input
            v-model="form.perms"
            maxlength="50"
            placeholder="请输入授权标识"
          />
        </el-form-item>
        <el-form-item
          label="排序"
          prop="order"
          v-if="form.type !== MENU_TYPE.BUTTON"
          :rules="[
            { required: true, message: '排序不能为空' },
            { pattern: /^[0-9]+$/, message: '只能为数字' },
          ]"
        >
          <el-input
            v-model="form.order"
            maxlength="10"
            placeholder="请输入排序"
          />
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-input v-model="form.icon" placeholder="请输入" />
        </el-form-item>
        <el-form-item
          label="菜单状态"
          required
          prop="status"
          v-if="form.type === MENU_TYPE.MENU"
        >
          <el-radio-group v-model="form.status">
            <el-radio :label="MENU_STATUS.NORMAL">启用</el-radio>
            <el-radio :label="MENU_STATUS.DISABLED">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="菜单导航"
          required
          prop="visible"
          v-if="form.type === MENU_TYPE.MENU"
        >
          <el-radio-group v-model="form.visible">
            <el-radio :label="MENU_VISIBLE.SHOW">显示</el-radio>
            <el-radio :label="MENU_VISIBLE.HIDE">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="form.remarks"
            type="textarea"
            resize="none"
            :rows="4"
            maxlength="50"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </main-content>
</template>

<script>
import MainContent from '@/components/MainContent.vue';
import { menuApi } from '@/api';
import {
  MENU_TYPE_TEXT,
  MENU_VISIBLE,
  MENU_STATUS_TEXT,
  MENU_STATUS,
  MENU_TYPE,
  TAG_TYPE,
  STATUS,
} from '@/constants/user-status';
import { formatTree, filterTree, assign } from '@/utils/tools';
import { cloneDeep } from 'lodash-es';
export default {
  components: { MainContent },
  data() {
    return {
      loading: false,
      MENU_TYPE_TEXT,
      MENU_TYPE,
      MENU_VISIBLE,
      MENU_STATUS_TEXT,
      MENU_STATUS,
      TAG_TYPE,
      visible: false,
      menuData: [
        {
          id: 1,
          a: '用户管理',
          b: '1',
          c: '目录',
          d: '-',
          e: '启用',
          f: 'sys:read:write',
          g: '管理用户相关操作',
          children: [
            {
              id: 11,
              a: '用户列表',
              b: '2',
              c: '菜单',
              d: '/sma/user/list',
              e: '启用',
              f: 'sys:read:write',
              g: '用户列表',
            },
          ],
        },
      ],
      menuRaw: [],
      menuDir: [],
      searchParams: {
        name: '',
        status: '',
      },
      defaultProps: {
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true,
      },
      form: {
        id: null,
        parentId: '0',
        type: MENU_TYPE.MENU,
        name: '',
        href: '',
        url: '',
        perms: '',
        order: '1',
        icon: '',
        status: MENU_STATUS.NORMAL,
        visible: MENU_VISIBLE.SHOW,
        remarks: '',
      },
    };
  },
  computed: {
    menuTypeOptions() {
      return Object.keys(MENU_TYPE_TEXT).map(key => ({
        name: MENU_TYPE_TEXT[key],
        value: key,
      }));
    },
    menuName() {
      return MENU_TYPE_TEXT[this.form.type] + '名称';
    },
    isDisabled() {
      return this.form.id !== null;
    },
  },
  created() {
    this.fetchMenuList();
  },
  methods: {
    fetchMenuList() {
      menuApi.getMenuList().then(res => {
        if (res.success) {
          this.menuRaw = cloneDeep(res.data);
          this.menuData = formatTree(res.data);
          this.handleMenuTypeChange(this.form.type);
        }
      });
    },
    // 菜单类型变化
    handleMenuTypeChange(type) {
      // 菜单类型时目录和菜单时，只能选择目录
      this.$refs['form']?.clearValidate();
      this.form.parentId = '0';
      if (type !== MENU_TYPE.BUTTON) {
        this.defaultProps.checkStrictly = true;
        this.menuDir = formatTree(
          filterTree(
            cloneDeep(this.menuRaw),
            item => item.type === MENU_TYPE.DIR,
          ),
        );
        return;
      }
      // 菜单类型为按钮时，只能选择叶子节点
      this.defaultProps.checkStrictly = false;
      this.menuDir = formatTree(
        filterTree(
          cloneDeep(this.menuRaw),
          item => item.type === MENU_TYPE.MENU,
        ),
      );
    },
    handleReset() {
      this.searchParams = {
        name: '',
        status: '',
      };
    },
    handleSearch() {
      this.menuData = filterTree(cloneDeep(this.menuRaw), item => {
        if (this.searchParams.name && this.searchParams.status) {
          return (
            item.name.includes(this.searchParams.name) &&
            item.status === this.searchParams.status
          );
        }
        if (this.searchParams.name === this.searchParams.status) return true;
        if (this.searchParams.name) {
          return item.name.includes(this.searchParams.name);
        }
        return item.status === this.searchParams.status;
      });
    },
    handleEdit(scope) {
      assign(this.form, scope.row);
      this.visible = true;
    },
    // 修改菜单状态
    handleChangeMenuStatus(menu) {
      const status =
        menu.status === STATUS.NORMAL ? STATUS.STOP : STATUS.NORMAL;
      this.handleSendRequest({ ...menu, status });
    },
    handleDelete(scope) {
      menuApi.deleteMenuById(scope.row.id).then(res => {
        if (res.success) {
          this.$message.success('删除成功');
          this.fetchMenuList();
        }
      });
    },
    handleSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.handleSendRequest(this.form);
        }
      });
    },
    // 发送修改请求
    handleSendRequest(form) {
      this.loading = true;
      const api = form.id ? menuApi.editMenu : menuApi.addMenu;
      api(form)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$message.success(form.id ? '修改成功' : '保存成功');
            this.visible = false;
            this.fetchMenuList();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      this.$refs['form'].clearValidate();
      this.$refs['form'].resetFields();
      this.form = {
        id: null,
        parentId: '0',
        type: MENU_TYPE.MENU,
        name: '',
        href: '',
        url: '',
        perms: '',
        order: '1',
        icon: '',
        status: MENU_STATUS.NORMAL,
        visible: MENU_VISIBLE.SHOW,
        remarks: '',
      };
    },
  },
};
</script>

<style></style>
